import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import secureAxios from '../../../core/api/client/secureAxios';
import { saveUserData } from '../containers/userSlice';
import { httpGet } from '../../utils';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';

const useUser = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        async function getUserData() {
            const response = await httpGet('/data/get-current-user', { [HTTP_OPTIONS.HANDLE_ERRORS]: true });
            if (response.data) {
                secureAxios.defaults.headers.common['csrf-token'] = response.data.csrf;
                dispatch(saveUserData(response.data));
            }
        }
        getUserData();
    }, [dispatch]);
};

export default useUser;
